<template>
	<MainContainer hide-header hide-footer :loading="state.loading" no-company-branding>
		<div class="grid flex-grow grid-cols-1 bg-[#F4F0E9] lg:grid-cols-12">
			<div class="col-span-1 flex max-lg:flex-col lg:col-span-5 xl:col-span-4">
				<div class="relative flex flex-grow flex-col items-center justify-center bg-primary px-8 py-8 lg:py-12">
					<span
						class="text-white border-white absolute start-0 top-0 m-4 flex h-9 w-9 cursor-pointer rounded-full border-2 duration-300 hover:bg-white hover:text-primary"
						@click="$backWithFallback($routeUrl.HomeUrl())"
					>
						<Icon name="mdi:close" class="h-full w-full p-1" />
					</span>
					<NuxtLink :to="$routeUrl.HomeUrl()">
						<img
							src="/img/app_logo_white.png"
							alt=""
							class="h-auto w-full max-w-[150px] duration-300 hover:scale-105 lg:max-w-[200px]"
						/>
					</NuxtLink>
					<span class="text-white mt-8 text-center text-3xl font-black lg:text-4xl">
						{{ $t("app_name") }}
					</span>
					<span class="text-white mt-12 text-center text-xl font-medium max-lg:hidden">
						{{ $t("app_motto") }}
					</span>
				</div>
				<div class="relative aspect-[333/25] flex-shrink-0 max-lg:-mt-[2px] lg:-ms-[2px] lg:aspect-[25/333]">
					<AuthWaveVSvg
						class="absolute left-0 top-0 h-full w-full text-primary max-lg:hidden rtl:-scale-x-100"
					/>
					<AuthWaveHSvg class="absolute left-0 top-0 h-full w-full text-primary lg:hidden" />
				</div>
			</div>
			<div
				class="col-span-1 flex flex-col items-center justify-center px-4 py-20 lg:col-span-7 lg:px-8 xl:col-span-8"
			>
				<ClientOnly>
					<AuthCard
						v-model:page="state.page"
						v-model:loading="state.loading"
						v-model:mode="state.mode"
						class="bg-white w-full max-w-lg rounded-3xl p-6 shadow-xl"
					/>
				</ClientOnly>
				<div class="absolute end-4 top-4">
					<BaseLanguageSelector
						button-class="max-lg:text-white max-lg:hover:text-gray-900 max-lg:focus:text-gray-900 max-lg:drop-shadow-sm"
					/>
				</div>
			</div>
		</div>
	</MainContainer>
</template>

<script setup lang="ts">
import AuthWaveHSvg from "~/assets/svg/auth_wave_h.svg"
import AuthWaveVSvg from "~/assets/svg/auth_wave_v.svg"
import { type UserAuthMode } from "~/stores/user"

definePageMeta({
	middleware: ["noauth", "payroll-module-domain-lock", "career-module-domain-lock", "career-module-domain-lock"]
})

const app = useNuxtApp()
const route = useRoute()
const userStore = useUserStore()

const state = reactive({
	loading: false,
	page: "login-1" as any,
	mode: "email" as UserAuthMode["id"]
})

const demoLogin = async () => {
	state.loading = true
	try {
		const r = await userStore.demoLogin()
		if (r.status == "enable") {
			await app.$router.push(app.$routeUrl.PanelDashboardUrl())
		}
	} catch (e) {
		app.$toastErrors(e)
	}
	state.loading = false
}

onMounted(() => {
	if (Number(route.query.login)) {
		state.page = "login-1"
	} else if (Number(route.query.register)) {
		state.page = "register"
	}
	if (!userStore.user?.id && route.query.demo) {
		demoLogin()
	}
})
</script>
